import React, { Component } from 'react';
import Table from 'react-bootstrap/Table';
import LinkButton from '../LinkButton';
import { MyGlobal, MyAlert } from '../GlobalContext';
import Container from 'react-bootstrap/esm/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Link } from 'react-router-dom';

export class LoadCarriers extends Component {
    static displayName = LoadCarriers.name;

    constructor(props) {
        super(props);
        var warehouseID = MyGlobal.warehouse;
        this.state = { data: [], loading: true, alertMessage: "", carriers: [] };
        this.history = props.history;
    }

    componentDidMount() {
        this.getCarriers();
    }
    goto(page) {
        this.history.push(page);
    }


    getCarriers() {
        this.setState({ loading: true });

        fetch(`api/Manifest/GetWHCarrierDetails?warehouseId=${MyGlobal.warehouse}`)
            .then(async response => {
                this.setState({ loading: false });
                // check for error response
                if (!response.ok) {
                    const errorText = await response.text();
                    console.error(errorText);
                    this.setState({ alertMessage: "Failed to load carriers!!"});
                }
                else {
                    const isJson = response.headers.get('content-type')?.includes('application/json');
                    const apiResponse = isJson ? await response.json() : null;
                    if (apiResponse) {
                        const data = apiResponse.data;
                        if (apiResponse.success) {
                            this.setState({ carriers: data });
                        }
                        else {
                            this.setState({ alertMessage: "Failed to load carriers!!  " + apiResponse.errorMessage });
                        }
                    }
                    else {
                        this.setState({ alertMessage: "Failed to load carriers!!" });
                    }
                }
            })
            .catch(error => {
                this.setState({ alertMessage: error });
            });
    }
    saveSelectedCarrier(selectedCarrier) {
        MyGlobal.carrier_settings = JSON.stringify({
            selectedCarrierId: selectedCarrier.carrierId,
            selectedCarrierName: selectedCarrier.carrierName
        });
    }
    render() {

        let alertMessage = this.state.alertMessage;
        alertMessage = alertMessage != "" ? <MyAlert variant="danger">{alertMessage}</MyAlert> : "";

        return <div className="container" >

            <Container>
                <Row  className="mb-3">
                    <Col xs={9}>
                    </Col>
                    <Col xs={3}>
                        <Link className="btn btn-success col-12 mb-2" to={{ pathname: "Manifesting" }}>Back</Link>
                    </Col>
                </Row>
            </Container>
            {alertMessage}
            {this.state.loading && <div> <em>Loading ... </em></div>}
            {this.state.carriers.length > 0 && <div>
                <Table responsive>
                    <thead>
                        <tr>
                            <th>Carrier</th>
                            <th>Unmanifested</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.carriers.map((item, index) => (
                            <tr key={index}>
                                <td>{item.carrierName}</td>
                                <td>{item.unmanifestedDocketCount}</td>
                                <td>
                                    <LinkButton className="btn btn-success col-12 mb-2" onClick={() => this.saveSelectedCarrier(item)} to="CreateManifest" >Create</LinkButton>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>
            }
        </div>
    }


}



